import React from 'react';
import CpsPage from './CpsPage';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { useUiAdminConfigsContext } from '@cs-cms/state-management';
import { CpsMaintenancePageState } from '@cs-cms/types';
import { Footer } from '../shared/Footer';
import TopBar from '../topBar/TopBar';
import { RoutePath } from '../types/RoutePath';

const MaintenancePage: React.FC = () => {
  const { uiAdminConfigState } = useUiAdminConfigsContext();

  const [maintenancePageState, setMaintenancePageState] = React.useState<CpsMaintenancePageState>();

  const { pathname } = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (uiAdminConfigState.maintenancePage) {
      const state = uiAdminConfigState.maintenancePage as CpsMaintenancePageState;
      if (!state.enabled) {
        navigate(RoutePath.HOME);
      } else {
        setMaintenancePageState(uiAdminConfigState.maintenancePage as CpsMaintenancePageState);
      }
    } else {
      return;
    }
  }, [navigate, uiAdminConfigState]);

  React.useEffect(() => {
    const isMaintenancePath = matchPath(`${RoutePath.MAINTENANCE}`, pathname);
    if (!isMaintenancePath) {
      navigate(`/${RoutePath.MAINTENANCE}`);
    }
  }, [navigate, pathname]);

  return (
    <CpsPage>
      <TopBar />
      {maintenancePageState?.enabled && (
        <div dangerouslySetInnerHTML={{ __html: maintenancePageState.pageContent || '' }} />
      )}
      <Footer />
    </CpsPage>
  );
};

export default MaintenancePage;
